import { Link } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';

const projects = [
  {
    image: 'https://public.readdy.ai/ai/img_res/faa04da0c6ef4286b548874573b51c84.jpg',
    service: 'Sealcoating',
    location: 'Retail Center - Edmond, OK',
    description: 'Complete sealcoating and restriping for 200-space retail parking lot'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=freshly%20painted%20yellow%20parking%20lot%20striping%20lines%20on%20black%20asphalt%2C%20crisp%20straight%20lines%20and%20ADA%20compliant%20handicap%20spaces%2C%20professional%20commercial%20striping%20work%2C%20office%20building%20parking%20area%2C%20aerial%20view%20showing%20perfect%20line%20work%2C%20bright%20sunny%20day&width=600&height=400&seq=work-002&orientation=landscape',
    service: 'Striping',
    location: 'Office Complex - Oklahoma City, OK',
    description: 'ADA-compliant striping and fire lane markings'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=commercial%20asphalt%20crack%20sealing%20and%20repair%20work%20in%20progress%2C%20professional%20crew%20filling%20cracks%20in%20parking%20lot%20pavement%2C%20hot%20rubberized%20crack%20filler%20application%2C%20industrial%20pavement%20maintenance%20equipment%2C%20close%20up%20detail%20of%20quality%20repair%20work%2C%20commercial%20property%20setting&width=600&height=400&seq=work-003&orientation=landscape',
    service: 'Crack Sealing',
    location: 'Shopping Center - Norman, OK',
    description: 'Preventative crack sealing and pothole repair'
  }
];

export default function RecentWork() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [isVisible]);

  return (
    <section ref={sectionRef} className="py-16 lg:py-24 bg-white">
      <div className="max-w-[1180px] mx-auto px-6 lg:px-8">
        <div className={`mb-12 lg:mb-16 ${isVisible ? 'lg:animate-fade-up' : 'lg:opacity-0'}`}>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4 leading-[1.05]" style={{ fontFamily: 'Oswald, sans-serif' }}>
            Recent Projects in Oklahoma City
          </h2>
          <div className="w-24 h-1 bg-yellow-400"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-4 lg:gap-6 mb-12">
          {/* Featured Project */}
          <div className={`lg:row-span-2 group cursor-pointer overflow-hidden rounded-2xl relative ${
            isVisible ? 'lg:animate-fade-up' : 'lg:opacity-0'
          }`}>
            <div className="w-full h-full">
              <img
                src={projects[0].image}
                alt={projects[0].location}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-100 group-hover:opacity-90 transition-opacity"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6 lg:p-7 text-white">
              <span className="inline-block px-4 py-2 bg-yellow-400 text-black text-sm font-bold rounded-full mb-4">
                {projects[0].service}
              </span>
              <h3 className="text-2xl font-bold mb-2">{projects[0].location}</h3>
              <p className="text-gray-200 leading-[1.45]">{projects[0].description}</p>
            </div>
          </div>

          {/* Smaller Projects */}
          {projects.slice(1).map((project, index) => (
            <div
              key={index}
              className={`group cursor-pointer overflow-hidden rounded-2xl relative h-64 ${
                isVisible ? 'lg:animate-fade-up' : 'lg:opacity-0'
              }`}
              style={{ animationDelay: `${80 * (index + 1)}ms` }}
            >
              <div className="w-full h-full">
                <img
                  src={project.image}
                  alt={project.location}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-100 group-hover:opacity-90 transition-opacity"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <span className="inline-block px-3 py-1 bg-yellow-400 text-black text-xs font-bold rounded-full mb-3">
                  {project.service}
                </span>
                <h3 className="text-xl font-bold mb-2">{project.location}</h3>
                <p className="text-sm text-gray-200 leading-[1.45]">{project.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className={`text-center ${isVisible ? 'lg:animate-fade-up lg:delay-240' : 'lg:opacity-0'}`}>
          <Link
            to="/our-work"
            className="inline-flex items-center justify-center px-8 py-4 bg-yellow-400 text-black font-bold rounded-lg hover:bg-yellow-500 transition-all whitespace-nowrap cursor-pointer lg:hover-lift"
          >
            View All Projects
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
